<template>
  <div id="app">
    <v-app id="entity-management">
      <v-navigation-drawer
        fixed
        v-model="drawer"
        app
        v-if="user"
      >
        <v-list dense>
          <v-list-tile
            v-for="item in items"
            :key="item.title"
            @click="navigationTo(item.route_name)"
          >
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-navigation-drawer>
      <v-toolbar color="#F2341B" dark
                 fixed
                 app
                 extended
                 extension-height="7">
        <v-toolbar-side-icon @click.stop="drawer = !drawer" v-if="user"></v-toolbar-side-icon>
        <v-toolbar-title>SKAYLINK ENTITY APP</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items v-if="user">
          <v-btn flat to="/">Entities</v-btn>
          <v-btn flat to="/ubermetrics-searches">Searches</v-btn>
          <v-divider
            class="mx-3"
            inset
            vertical
          ></v-divider>
          <v-btn flat @click="handleSignOut">Sign Out</v-btn>
        </v-toolbar-items>
        <v-dialog
          v-model="loading"
          hide-overlay
          persistent
          width="300"
        >
          <v-card
            color="primary"
            dark
          >
            <v-card-text>
              Loading... Please wait...
              <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-content>
        <v-container fluidt>
          <v-layout justify-start>
            <router-view v-on:TriggerLoading="triggerLoading"/>
          </v-layout>
        </v-container>
      </v-content>
      <v-footer color="#F2341B" app inset>
        <v-layout justify-center
                  align-center>
          <span class="white--text">Skaylink &copy; 2025</span>
        </v-layout>

      </v-footer>
    </v-app>
  </div>
</template>


<script>
  import axios from 'axios'
  import { Auth } from '@aws-amplify/auth'
  import AmplifyStore from './store/store'

  export default {
    name: 'app',
    methods: {
      navigationTo: function (route_name) {
        this.$router.push({ name: route_name })
      },
      triggerLoading: function (value) {
        this.loading = value
      },
      handleSignOut: function () {
        var self = this
        Auth.signOut()
          .then(function () {
            AmplifyStore.commit('setUser', null)
            self.$router.push({ path: '/auth' })
          })
          .catch(function (e) {
            console.error('Sign out error', e)
          })
      },
    },
    computed: {
      user: function () {
        return AmplifyStore.state.user
      },
    },
    mounted: function () {
      if (AmplifyStore.state.user) {
        var idToken = AmplifyStore.state.user.signInUserSession.idToken.jwtToken
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + idToken
      }
    },
    data: function () {
      return {
        loading: false,
        items: [
          { title: 'Entities', icon: 'home', route_name: 'entity_list' },
          { title: 'Ubermetrics Searches', icon: 'search', route_name: 'ubermetrics_searches' },
          { title: 'Orphaned Searches', icon: 'link_off', route_name: 'orphaned_searches' },
          { title: 'Import Logs', icon: 'list', route_name: 'imports' },
          { title: 'Search Update', icon: 'save_alt', route_name: 'search_update' },
          { title: 'Entity Import', icon: 'input', route_name: 'entity_import' },
          { title: 'Tag Change', icon: 'input', route_name: 'tag_change' },
          { title: 'Entity Export', icon: 'save_alt', route_name: 'entity_export' },
          { title: 'Entity Event Regex', icon: 'code', route_name: 'event_regex' },
          { title: 'Add Event Regex', icon: 'add', route_name: 'event_regex_create' },
          { title: 'Add Entity', icon: 'add', route_name: 'entity_create' },
          { title: 'Add Search', icon: 'add', route_name: 'ubermetrics_searches_create' },
          { title: 'Profile', icon: 'account_circle', route_name: 'Profile' },
          { title: 'UM Search Metrics', icon: 'bar_chart', route_name: 'ubermetrics_metrics' },
        ],
        drawer: null,
        right: null,
      }
    },
  }
</script>
